import { isDateOnly } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { isValid, parseISO, startOfDay } from 'date-fns';
import Joi from 'joi';
import { AWSDateSchema } from '../entities/shared/utils';

export { AWSDateSchema, AWSDateTimeSchema } from '../entities/shared/utils';

export const customJoiDate = Joi.extend((joi) => {
  return {
    type: 'customJoiDate',
    base: joi.date(),
    messages: {
      'awsDate.notDate': 'The {{#label}} is not a valid date.',
      'date.pastInvalid': 'The {{#label}} cannot be in the past.',
      'date.futureInvalid': 'The {{#label}} cannot be in the future.'
    },
    validate: (value, helpers) => {
      // Base validation regardless of the rules applied
      const errors: Joi.ErrorReport[] = [];
      if (value != null && !(value instanceof Date)) errors.push(helpers.error('awsDate.notDate'));

      return {
        errors,
        value
      };
    },
    rules: {
      AWSDate: {
        method() {
          return this.$_addRule('AWSDate');
        },
        validate(value, helpers) {
          const result = AWSDateSchema.validate(helpers.original);
          return result.error ? helpers.error('awsDate.notDate') : result.value;
        }
      },
      AWSDateTime: {
        method() {
          return this.$_addRule('AWSDateTime');
        },
        validate(value) {
          return value.toISOString();
        }
      },
      pastInvalid: {
        method() {
          return this.$_addRule('pastInvalid');
        },
        validate(value, helpers) {
          if (value != null) {
            const today = startOfDay(new Date());
            const date = typeof helpers.original === 'string' && isDateOnly(helpers.original) ? parseISO(helpers.original) : value;
            if (!isValid(date)) return helpers.error('awsDate.notDate');
            const fromDate = startOfDay(date);

            if (fromDate.getTime() < today.getTime()) return helpers.error('date.pastInvalid');
          }

          return value;
        }
      },
      futureInvalid: {
        method() {
          return this.$_addRule('futureInvalid');
        },
        validate(value, helpers) {
          if (value != null) {
            const today = startOfDay(new Date());
            const date = typeof helpers.original === 'string' && isDateOnly(helpers.original) ? parseISO(helpers.original) : value;
            if (!isValid(date)) return helpers.error('awsDate.notDate');
            const fromDate = startOfDay(date);

            if (fromDate.getTime() > today.getTime()) return helpers.error('date.futureInvalid');
          }

          return value;
        }
      }
    }
  };
});
